
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/cookies",
      function () {
        return require("private-next-pages/nl/cookies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/cookies"])
      });
    }
  